import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom-v5-compat";
import { PACKAGES_QUERY_PARAM } from "@b2bportal/core-packages";
import type { AppDispatch } from "@b2bportal/core-types";
import { getPackageRoutes } from "@b2bportal/core-utilities";
import { fetchPackageCarsShop } from "../../../store";
import { PackageBaseSelectors } from "@/store";

export const usePackageCarsShopPageFetch = ({
  opaqueShopRequestContext,
  opaqueShopRequestVehicle,
}: {
  opaqueShopRequestContext: string;
  opaqueShopRequestVehicle: string;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  // We don't need search, just grab the package token
  const packageToken = useSelector(
    PackageBaseSelectors.getCurrentActivePackageToken
  );
  const packageType = useSelector(
    PackageBaseSelectors.getCurrentActivePackageType
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (packageToken && opaqueShopRequestContext && opaqueShopRequestVehicle) {
      dispatch(
        fetchPackageCarsShop({
          packageToken,
          opaqueShopRequestContext,
          opaqueShopRequestVehicle,
        })
      )
        .unwrap()
        .then(() => {
          // NOTE: Cars is being updated to go from car selection to checkout directly.
          // We still need to go to the shop page and make a fetchPackageCarsShop call bc we need the
          // opaque token for checkout, otherwise when we /completePackage the cars stack isn't happy we didn't go through shop.
          const checkoutParams = new URLSearchParams(searchParams);
          checkoutParams.set(PACKAGES_QUERY_PARAM.packageType, packageType);
          checkoutParams.set(PACKAGES_QUERY_PARAM.packageToken, packageToken);
          navigate(
            `${getPackageRoutes().FULL_ROUTES.CHECKOUT}?${checkoutParams.toString()}`,
            { replace: true }
          );
        });
    }

    // Intentionally run once on mount: fetches shop data then redirects to checkout.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
